<template>
  <div>
    <section role="dialog" tabindex="-1" class="slds-modal slds-fade-in-open slds-modal_small" aria-labelledby="modal-heading-01" aria-modal="true" aria-describedby="modal-content-id-1">
      <div class="slds-modal__container">
        <header class="slds-modal__header">
          <div class="slds-grid slds-gutters">
            <div class="slds-size_3-of-12" >
              <div class="side-banner"></div>
            </div>
            <div class="slds-size_9-of-12" style="margin-left:-10px;">
              <div>
                <h1 id="modal-heading-01" class="slds-text-heading_medium slds-hyphenate" style="color: #080707;font-weight: bold;padding:3px;">Demo Boost</h1>
                <div class="slds-text-body_small slds-align_absolute-center" style="font-size: 13px;">Q Branch will set up a few things for you.</div>
              </div>
            </div>
          </div>
        </header>
        <div class="slds-modal__content slds-p-around_medium" id="modal-content-id-1">
          <div class="slds-grid slds-gutters">
            <div class="slds-size_6-of-12" style="padding-left:60px;">
              <div v-for="tile in tiles.slice(0,Math.ceil(tiles.length / 2))" v-bind:key="tile.title" class="slds-grid">
                  <tile v-bind:tile="tile" v-bind:isMqVersion="mqVersion"/>
              </div>
            </div>
            <div class="slds-size_6-of-12" style="padding-left:30px;">
              <div v-for="tile in tiles.slice(Math.ceil(tiles.length / 2),tiles.length)" v-bind:key="tile.title" class="slds-grid">
                <tile v-bind:tile="tile" v-bind:isMqVersion="mqVersion"/>
              </div>
            </div>
          </div>
        </div>
        <footer class="slds-modal__footer">
            <button class="slds-button slds-button_brand" v-on:click="onClickStart" style="width:fit-content;text-align:right">Boost</button>
            <button class="slds-button slds-button_neutral" v-on:click="closeModal" style="width:fit-content;text-align:right">Close</button>
        </footer>
      </div>
    </section>
    <div class="slds-backdrop slds-backdrop_open"></div>
  </div>
</template>

<script>
  import boostMq from "../boost_mq.js";
  import tile from "./tiles.vue";

  export default {
    name: 'demoBoostDialog',
    props: {

    },
    components: {
      tile
    },
    data() {
      return {
        tiles: [],
        mqVersion : true,
      };
    },
    methods:{
      async init() {
          this.tiles = [];
          let taskList = await boostMq.boostTaskList();
          for(let task of taskList.data){
            this.tiles.push({
              completed: false,
              title: task,
              description: ""
            });
          }
      },
      async onClickStart(){
        await boostMq.initiateBoostMQ();
        this.$emit('on-demo-boost-completion',true);
      },
      closeModal(){
        this.$emit('on-demo-boost-completion',true);
      }
    },
    mounted() {
      this.init();
    },
  }
</script>
<style>
.slds-button {
  width: 100%;
  margin-top: 5px;
}

.slds-col {
  text-align: center;
  padding-top: 0.8rem;
  padding-bottom: 0.5rem;
}

.leftgrid {
  margin-top: 0.85em;
  padding-top: 0px;
}

.modal-container {
  background: black;
  position: absolute;
  top: 0;
  height: 100%;
  width: 960px;
}

.fleft {
  float: left;
}

.slds-text-heading_small {
  font-weight: bold;
}

.side-banner{
  height: 6rem;
  background-size: contain;
  background-repeat: no-repeat;
  display:block;
  background-image: url("/astro-modal.png");
}
.slds-modal__header{
  padding:1rem 1rem 0 1rem;
}
</style>